(function () {
  new MutationObserver((mutations, observer) => {
    const appLinkTarget = document.querySelectorAll(".shopify-app-block link");
    if (!appLinkTarget) {
      return;
    }
    observer.disconnect();

    appLinkTarget.forEach(function (linkTag) {      
      if (linkTag.href.includes("xo-gallery") && linkTag.type === "text/css") {      

        linkTag.media = "none";
        linkTag.onload = "this.onload=null;this.media='all'";
      }
    });
  }).observe(document.body, { childList: true });

  (function () {
    // <link rel="dns-prefetch" href="https://cdn.judge.me"></link>
    new MutationObserver((mutations, observer) => {
      const headScriptTarget = document.querySelectorAll("head link");
      if (!headScriptTarget) {
        return;
      }
      observer.disconnect();

      headScriptTarget.forEach(function (scriptTag) {
        
        if (scriptTag.href.includes("cdn.judge.me")) {
        
          scriptTag.removeAttribute("rel");
          // scriptTag.parentNode.removeChild(scriptTag);
        }
      });

      // /422109829285510?v=2.9.111&r=stable
    }).observe(document.body, { childList: true });
  })();
})();
